module.exports = __webpack_public_path__ + "static/img/纪录片.969187d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/纪录片.png
// module id = Qhzx
// module chunks = 1